import React, { useEffect } from 'react'
import BioData from '../../pages/Biodata/Biodata';

const BiodataMobile = (props) => {
    useEffect(() => props.setShow(false), [props]);
    return <BioData />
}

export default BiodataMobile;